import React, { useState, useEffect } from 'react';
import axios from 'axios';
import defaultLogo from '../assets/images/splash.png';
import { getActiveToken, getActiveAuthRole } from '../utils/authStorage';

const API_URL = process.env.REACT_APP_REGIT_SERVICE_URL || '';

// Créer un événement personnalisé pour la mise à jour du logo
export const LOGO_UPDATE_EVENT = 'logo-updated';
export const notifyLogoUpdate = () => {
  window.dispatchEvent(new CustomEvent(LOGO_UPDATE_EVENT));
};

export default function DynamicLogo({ className }) {
  const [updateCounter, setUpdateCounter] = useState(0);
  const [logoData, setLogoData] = useState(null);
  const [imageError, setImageError] = useState(false);

  // Écouter l'événement de mise à jour du logo
  useEffect(() => {
    const handleLogoUpdate = () => {
      setUpdateCounter(prev => prev + 1);
      setImageError(false);
    };

    window.addEventListener(LOGO_UPDATE_EVENT, handleLogoUpdate);
    return () => window.removeEventListener(LOGO_UPDATE_EVENT, handleLogoUpdate);
  }, []);

  // Récupérer les données du logo
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const token = getActiveToken();
        const role = getActiveAuthRole();

        if (!token || role === 'merchant') {
          setLogoData(null);
          return;
        }

        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        };

        console.log('Tentative de récupération du logo depuis:', `${API_URL}/logo`);

        const response = await axios.get(`${API_URL}/logo`, config);
        if (response.data.success && response.data.logo) {
          if (response.data.logo.gridfsId) {
            setLogoData(response.data.logo);
            setImageError(false);
          } else {
            console.warn('Logo trouvé mais pas de gridfsId');
            setLogoData(null);
          }
        } else {
          setLogoData(null);
        }
      } catch (err) {
        console.warn('Erreur lors du chargement du logo:', err);
        if (err.response?.status === 401) {
          console.warn('Token invalide ou expiré');
        }
        setLogoData(null);
      }
    };

    fetchLogo();
  }, [updateCounter]);

  // Appliquer les couleurs dynamiques
  useEffect(() => {
    if (logoData) {
      const root = document.documentElement;
      if (logoData.color1) root.style.setProperty('--color-primary', logoData.color1);
      if (logoData.color2) root.style.setProperty('--color-secondary', logoData.color2);
      if (logoData.color3) root.style.setProperty('--color-accent', logoData.color3);
      if (logoData.color4) root.style.setProperty('--color-neutral', logoData.color4);
    }
  }, [logoData]);

  return (
    <img
      src={`${API_URL}/logo/file?t=${new Date().getTime()}&u=${updateCounter}`}
      alt="Logo"
      className={className}
      onError={(e) => {
        console.warn('Erreur de chargement de l\'image, utilisation du logo par défaut');
        e.target.src = defaultLogo;
      }}
    />
  );
}